import { useAuth } from 'auth/context/AuthContext';
import { usePatchFhirEncounterMutation } from 'graphql/generated/remote-schema-hasura';
import { useCallback, useRef } from 'react';
import { Roles } from '../firebase/interfaces';

export function useInAppointmentActions(
  currentAppointmentCodexId: string,
  currentEncounterId?: string | null,
  notes?: string,
): {
  leftEvent: () => Promise<void>;
  saveNotes: (notes?: string) => Promise<void>;
} {
  const [patchFhirEncounterMutation] = usePatchFhirEncounterMutation({});
  const { user } = useAuth();

  const didLeftExecuted = useRef(false);

  const saveNotes = useCallback(
    async (notes?: string) => {
      await patchFhirEncounterMutation({
        variables: {
          encounterCodexId: currentEncounterId ?? '',
          followupRecommendations: '',
          providerNotes: notes ?? '',
          providerSummary: '',
        },
      });
    },
    [patchFhirEncounterMutation, currentEncounterId],
  );

  const providerLeft = useCallback(() => {
    return saveNotes(notes);
  }, [saveNotes, notes]);

  const leftEvent = useCallback(async () => {
    if (didLeftExecuted.current) return;
    didLeftExecuted.current = true;
    const role = user?.role;
    if (role === Roles.PATIENT) {
      return;
    }
    return await providerLeft();
  }, [providerLeft, user?.role]);

  return { leftEvent, saveNotes };
}
